export default __webpack_public_path__ + "static/mirror-bc088ba5c9fac8e5c93df57aa7306edb.svg";